@if (data.text) {
  <section
    [class.bg-gray-light]="data.background === 'gray'"
    [class.bg-white]="data.background === 'white'"
    class="py-12">
    @if (textSeo(); as textSeo) {
      <app-text-seo [textSeo]="textSeo" />
    }
  </section>
}
